/**
 * Debounce events to prevent trigger too much in a short space of time
 * @param func Callback
 * @param delay 
 * @returns callback is performed on return
 */
export const debounce = (func: Function, delay: number) => {
  let inDebounce: ReturnType<typeof setTimeout>;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay || 100);
  }
}